const activeEnv =
  process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development";

const configs = require(`./${activeEnv}.js`);
module.exports = configs;
